import { SET_USER_LOGIN, SET_USER_DATA, CLEAR_USER } from "./actionTypes"

const initialState = {
  no: null,
  id: "",
  type: "",
  sub_role: null,
  alarm: 0,
  balance: {},
  point: 0,
  state: "",
  total_unread_messages: 0,
  total_messages: 0,
  important_message_yn: "N",
  use_point_yn: "Y",
  comp_see_yn: "N",
  losing_type: "G",
  activeGameTypes: [],
  use_krw_yn: null,
  use_usdt_yn: null,
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_LOGIN:
      return { ...state, ...action.payload }
    case SET_USER_DATA:
      return { ...state, ...action.payload }
    case CLEAR_USER:
      return { ...initialState }
    default:
      return state
  }
}

export default user